module.exports = __webpack_public_path__ + "img/gsgc2901_1.44f992b8.svg";